import { DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { YoutubeEmbedUrlPipe } from '@pipes/youtube-embed-url/youtube-embed-url.pipe';

@Component({
  selector: 'app-video-modal',
  imports: [YoutubeEmbedUrlPipe],
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss']
})
export class VideoModalComponent {
  public data: { title: string; videoUrl: string } = inject(DIALOG_DATA) as { title: string; videoUrl: string };
}
